import React from "react";
import "./update.css";
const Loader = () => {
  return (
    <div className="bg-white flex justify-center items-center">
      <video
        className="loader flex justify-center items-center"
        autoPlay
        muted
        loop
      >
        <source src="loader.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default Loader;
